import { connect } from 'react-redux';
import CarteiraVirtual from './carteiraVirtual';

export default connect()(CarteiraVirtual);
